import React from 'react';
import { Alert, Tag, Wrap, WrapItem } from '@televet/kibble-ui';
import { useHistory } from 'react-router-dom';
import partial from 'lodash-es/partial';
import { AutomationsFieldContainer, AutomationsFieldDescription, AutomationsFieldLabel } from '../../Layout';
import { useGetParentAutomations } from 'pages/Automations/hooks';
import { useCurrentAutomationId } from 'pages/Automations/hooks/useCurrentAutomationId';
import { useGetAutomationsBasePath } from 'pages/Automations/hooks/useGetAutomationsBasePath';

export const LinkedAutomations = (): JSX.Element => {
  const currentAutomationId = useCurrentAutomationId();
  const history = useHistory();
  const { parentAutomations } = useGetParentAutomations(currentAutomationId);
  const { automationsBasePath } = useGetAutomationsBasePath();

  const handleParentAutomationClick = (automationId: string): void => {
    history.push(`${automationsBasePath}/${automationId}/compose`);
  };

  return (
    <AutomationsFieldContainer>
      <AutomationsFieldLabel>Linked Automations</AutomationsFieldLabel>
      <AutomationsFieldDescription>
        This automation is triggered by prompts within the following automations:
      </AutomationsFieldDescription>
      <Wrap spacing="1" className="Automations__ParentAutomationsField">
        {!parentAutomations.length ? (
          <Alert
            title="This automation is not yet linked from another automation"
            description="To link this automation, select it as a Next Step within another automation prompt."
            status="info"
            hideCloseButton
          />
        ) : (
          parentAutomations.map((parent) => {
            return (
              <WrapItem key={parent?.id}>
                <Tag
                  size="md"
                  label={`${parent?.name}${!parent?.isPublished ? ' (Inactive)' : ''}`}
                  color="text.onContrast"
                  bgColor="background.primary"
                  _hover={{
                    bg: 'background.primary.hover',
                  }}
                  cursor="pointer"
                  onClick={partial(handleParentAutomationClick, parent?.id || '')}
                />
              </WrapItem>
            );
          })
        )}
      </Wrap>
    </AutomationsFieldContainer>
  );
};
